export type SigningOperation = 'DELIVER' | 'CONFIRM'

/**
 * One envelope of a run. On the way out `data` is the canonical SignedInfo to sign, on the way back
 * it is the signature over it, both base64.
 */
export interface SigningItem {
  index: number
  operation: SigningOperation
  data: string
}

export interface StartRunResponse {
  runId: string
  messageCount: number
  waitingCount: number
  items: SigningItem[]
}

export interface SubmitSignaturesRequest {
  certificateDer: string
  signatures: SigningItem[]
}

export interface AcceptedRunResponse {
  runId: string
}

export type RunPhase = 'SIGNING' | 'PROCESSING' | 'DONE' | 'FAILED' | 'EXPIRED'

export interface RunCounts {
  applied: number
  alreadyApplied: number
  noMatch: number
  unreadable: number
  dropped: number
  deliverRefused: number
  confirmRefused: number
  retry: number
}

export interface RunStatusResponse {
  runId: string
  phase: RunPhase
  counts: RunCounts | null
  waitingCount: number
  failureMessage: string | null
}

/**
 * The codes t1-server puts in the error body's `message`. Matched by prefix: the poll failure carries
 * the gateway's reason after a colon.
 */
export const SerbianFetchErrorCode = {
  RUN_OPEN: 'SERBIAN_FETCH_RUN_OPEN',
  POLL_FAILED: 'SERBIAN_FETCH_POLL_FAILED',
  RUN_EXPIRED: 'SERBIAN_FETCH_RUN_EXPIRED',
  RUN_NOT_SIGNING: 'SERBIAN_FETCH_RUN_NOT_SIGNING',
  RUN_OWNED_BY_ANOTHER_ADMINISTRATOR: 'SERBIAN_FETCH_RUN_OWNED_BY_ANOTHER_ADMINISTRATOR',
  SIGNATURES_INCOMPLETE: 'SERBIAN_FETCH_SIGNATURES_INCOMPLETE',
  CERTIFICATE_INVALID: 'SERBIAN_FETCH_CERTIFICATE_INVALID',
  SIGNATURE_MISMATCH: 'SERBIAN_FETCH_SIGNATURE_MISMATCH',
  RUN_FAILED: 'SERBIAN_FETCH_RUN_FAILED',
  SIGNING_NOT_COMPLETED: 'SERBIAN_FETCH_SIGNING_NOT_COMPLETED',
} as const
